export const landingRoutes = [
  {
    path: '/',
    lazy: async () => {
      const { LandingRoute } = await import('./LandingRoute/LandingRoute');
      return { Component: LandingRoute };
    },
  },
  {
    path: '/landing/login',
    lazy: async () => {
      const { LoginRoute } = await import('./LoginRoute/LoginRoute');
      return { Component: LoginRoute };
    },
  },
  {
    path: '/landing/register',
    lazy: async () => {
      const { RegisterRoute } = await import('./RegisterRoute/RegisterRoute');
      return { Component: RegisterRoute };
    },
  },
  {
    path: '/landing/forgot-password',
    lazy: async () => {
      const { ForgotPasswordRoute } =
        await import('./ForgotPassword/ForgotPassword');
      return { Component: ForgotPasswordRoute };
    },
  },
];

export const protectedLandingRoutes = [
  {
    path: '/',
    lazy: async () => {
      const { LandingRoute } = await import('./LandingRoute/LandingRoute');
      return { Component: LandingRoute };
    },
  },
  {
    path: '/landing/plan',
    lazy: async () => {
      const { PlanRoute } = await import('./PlanRoute/PlanRoute');
      return { Component: PlanRoute };
    },
  },
];
